import Pimple from '../pimple';
import Router from '../router';
import ModalStack from './modal/modalStack';

/**
 * Create editor container
 *
 * @return {Pimple}
 */
export default function createContainer() {
    const container = new Pimple();

    container.set('router', Router);

    container.share('unit.measurementsConverter', () => new Ofcs.Unit.MeasurementsConverter());

    container.set('unit.lengthUnit.identifier', 'millimeter');
    container.set('unit.lengthUnit.conversionFactor', 1);

    container.share('unit.lengthUnit', c => new Ofcs.Unit.LengthUnit(
        c.get('unit.lengthUnit.identifier'),
        c.get('unit.lengthUnit.conversionFactor'),
    ));

    container.share('modal.stack', () => new ModalStack());

    return container;
}
